export class ActivationRequest {
  public userNumber: string;
  public hardwareId: string;
}
